import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
    page: {
        global: {},
        scenes: {
            layers: []
        }
    },
    customData: {},
    originLayers: [],
    originLayersShowMap: {},
    backPopup: null,
    compMap: {},
    dataCenter: {
        eventTable: {},
        // 组件层级
        level: 1
    },
    prefetched: false,
    originPageData: null,
    multiPageDataMap: {},
    isMultiPage: false,
    io: null,
    observeCount: 0,
    hasTrackLayers: [],
    sliderMap: {},
}

function walkNode (node = {}, cb) {
    const { children } = node
    cb(node)
    if (!children || !children.length) return
    node.children.map(item => {
        walkNode(item, cb)
    })
}

const getters = {
    global: state => state.page.global,
    allLayers: state => {
    // eslint-disable-next-line prefer-const
        let flatenList = {}
        const addToList = item => (flatenList[item.id] = item)
        state.originLayers.map(layer => {
            walkNode(layer, addToList)
        })
        return flatenList
    }
}

export const createStore = () => {
    return new Vuex.Store({
        state,
        getters,
        actions,
        mutations
    })
}
